<template>
  <div class="flex flex-col space-y-4">
    <NProgress
      progress="primary"
    />

    <NProgress
      progress="error"
    />

    <NProgress
      progress="indigo"
    />

    <NProgress
      progress="orange"
    />
  </div>
</template>
